import {
  Button,
  AppBar,
  Box,
  Grid,
  Avatar,
} from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./header.scss";
import { useMediaQuery } from "react-responsive";
import UserMenu from "./UserMenu";
import Typography from "@mui/material/Typography";
import { isAdmin } from "../../utils/helpers";

export default function Default() {
  const isMobile = useMediaQuery({ maxWidth: "960px" });
  const redirect = useNavigate();

  return (
    <>
      <AppBar className="app-header" position="fixed" open={true}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item xs={6} className="header-left">
            <div className="left-divider"></div>
            {!isAdmin() && <div>
              <Typography className="header-status-label">Status</Typography>
              <Typography className="header-status-text">
                <span>Active</span>
              </Typography>
            </div>}
          </Grid>
          <Grid item xs={6} className="header-right">
            <UserMenu />
          </Grid>
        </Grid>
      </AppBar>
    </>
  );
}
